/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const PRIVILEGED_EP_SYS_VARS_FRANCHISEE = 'SystemVariablesFranchisee';
export const PRIVILEGED_EP_SYS_VARS_ACCOUNTS = 'SystemVariablesIntegrationAccountsAccounting';
export const PRIVILEGED_EP_SYS_VARS_LEDGER = 'SystemVariablesLedger';
export const PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT = 'SystemVariablesEstimatingMeasurement';
export const PRIVILEGED_EP_SYS_VARS_JOBS_DPP = 'SystemVariablesJobsDpp';
export const PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE = 'SystemVariablesJobsPermitDateAndCostCenter';
export const PRIVILEGED_EP_SYS_VARS_SALES = 'SystemVariablesSales';
export const PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS = 'SystemVariablesEstimatingOrders';
export const PRIVILEGED_EP_SYS_VARS_ACCOUNTING = 'SystemVariablesAccounting';
export const PRIVILEGED_EP_USER_UPDATE = 'UserUpdate';
export const PRIVILEGED_EP_USER_VERIFICATION = 'UserVerification';
export const PRIVILEGED_EP_USER_SEND_EMAILS_FROM_VERIFICATION = 'UserAccessToMultipleOffices';
export const PRIVILEGED_EP_PB_APPLY_DEFAULT_MARKUPS = 'PriceBookApplyDefaults';
export const PRIVILEGED_EP_INVOICE_AMOUNT_CORRECTION = 'InvoiceAmountCorrection';
export const PRIVILEGED_EP_CLOSE_FINANCIAL_YEAR = 'CloseEmptyFinancialYear';
export const PRIVILEGED_EP_ESTIMATING_FEE_EXCLUSIONS = 'EstimatingFeeExclusions';
